module.exports = __webpack_public_path__ + "static/media/lunch5.57e41ebd.png";